import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import { useNavigate } from "react-router-dom";

const MANAGE_URL = "/candidate/job/application/manage";

const Charts = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("webvi_authToken");

    fetch("https://sdsjobseekers.runasp.net/api/Dashboard/candidate", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setDashboardData(res.data);
        }
      })
      .catch((err) => console.error("API Error:", err));
  }, []);

  const applied = dashboardData?.appliedJobs || 0;
  const shortlisted = dashboardData?.shortlistedJobs || 0;
  const rejected = dashboardData?.rejectedJobs || 0;
  const notifications = dashboardData?.unreadNotifications || 0;

  const data = [
    {
      name: "Job Statics",
      AppliedJobs: applied,
      ShortlistedJobs: shortlisted,
      RejectedJobs: rejected,
    },
  ];

  return (
    <div className="container mt-4">
      <div className="card border-0 shadow-lg rounded-4">
        {/* Header */}
        <div className="card-header bg-white border-0 d-flex justify-content-between align-items-center px-4 py-3">
          <div>
            <h5 className="mb-0 fw-bold">📊 Job Analytics</h5>
            <small className="text-muted">Overview of your activity</small>
          </div>
          <span className="badge bg-primary px-3 py-2 rounded-pill">
            Live Data
          </span>
        </div>

        <h3 className="mb-0 fw-bold m-4">Boost Your Profile Visibility</h3>
        <h5 className="text-muted small m-4">
          Stay active! Candidates who log in regularly and keep their profiles
          updated are featured at the top of recruiter searches, increasing
          hiring chances by up to 3x.
        </h5>

        <div className="card-body px-4">
          {/* Top Stats */}
          <div className="row g-3 mb-4">
            {/* Applied Jobs */}
            <div className="col-md-3">
              <div
                className="card border-0 shadow-sm h-100 rounded-3"
                onClick={() => navigate(`${MANAGE_URL}?status=all`)}
                style={{ cursor: "pointer" }}
              >
                <div className="card-body d-flex justify-content-between align-items-center shadow">
                  <div>
                    <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                      Applied Jobs
                    </div>
                    <h3 className="fw-bold text-primary mb-0">{applied}</h3>
                  </div>
                  <div className="bg-success bg-opacity-10 text-success p-3 rounded-circle">
                    📄
                  </div>
                </div>
              </div>
            </div>

            {/* Shortlisted */}
            <div className="col-md-3">
              <div
                className="card border-0 shadow-sm h-100 rounded-3"
                onClick={() => navigate(`${MANAGE_URL}?status=shortlisted`)}
                style={{ cursor: "pointer" }}
              >
                <div className="card-body d-flex justify-content-between align-items-center shadow">
                  <div>
                    <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                      Shortlisted
                    </div>
                    <h3 className="fw-bold text-success mb-0">{shortlisted}</h3>
                  </div>
                  <div className="bg-success bg-opacity-10 text-success p-3 rounded-circle">
                    ✅
                  </div>
                </div>
              </div>
            </div>

            {/* Rejected */}
            <div className="col-md-3">
              <div
                className="card border-0 shadow-sm h-100 rounded-3"
                onClick={() => navigate(`${MANAGE_URL}?status=rejected`)}
                style={{ cursor: "pointer" }}
              >
                <div className="card-body d-flex justify-content-between align-items-center shadow">
                  <div>
                    <div className="text-xs font-weight-bold text-danger text-uppercase mb-1">
                      Rejected
                    </div>
                    <h3 className="fw-bold text-danger mb-0">{rejected}</h3>
                  </div>
                  <div className="bg-danger bg-opacity-10 text-danger p-3 rounded-circle">
                    ❌
                  </div>
                </div>
              </div>
            </div>

            {/* Notifications */}
            <div className="col-md-3">
              <div
                className="card border-0 shadow-sm h-100 rounded-3"
                onClick={() => navigate("/notifications")}
                style={{ cursor: "pointer" }}
              >
                <div className="card-body d-flex justify-content-between align-items-center shadow">
                  <div>
                    <div className="text-xs font-weight-bold text-warning text-uppercase mb-1">
                      Notifications
                    </div>
                    <h3 className="fw-bold text-warning mb-0">{notifications}</h3>
                  </div>
                  <div className="bg-warning bg-opacity-10 text-danger p-3 rounded-circle">
                    💬
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Chart Section */}
          <div className="card border-0 shadow-sm rounded-3">
            <div className="card-body text-center">
              <h6 className="fw-semibold mb-3">Performance Overview</h6>

              <div className="mx-auto" style={{ maxWidth: "700px", height: 320 }}>
                <ResponsiveContainer>
                  <BarChart
                    data={data}
                    barGap={20}
                    barCategoryGap="30%"
                    margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis allowDecimals={false} />
                    <Tooltip />
                    <Bar dataKey="AppliedJobs" fill="#397fd8" barSize={40} radius={[8, 8, 0, 0]} />
                    <Bar dataKey="ShortlistedJobs" fill="#198754" barSize={40} radius={[8, 8, 0, 0]} />
                    <Bar dataKey="RejectedJobs" fill="#fd7482" barSize={40} radius={[8, 8, 0, 0]} />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Charts;